// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Afidium
import { UIModule } from 'libraries/ui/ui.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { GenericModule } from 'libraries/module/generic.module';
import { ApiModule } from 'libraries/module/api.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { IaqobohotelRoutingModule } from './iaqobohotel.routing';
import { IaqobohotelComponent } from './iaqobohotel.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';

import { LanguageService } from 'libraries/service/language/language.service';
import { HotelService } from 'libraries/hotel/services/hotel.service';
import { FormService } from 'libraries/service/form/form.service';
import { HelperService } from 'libraries/hotel/services/helper.service';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { BreadcrumbService } from 'libraries/hotel/services/breadcrumb.service';

// Components
import { TravellerCardModule } from 'libraries/component/travellerCard/travellerCard.module';
import { ConfigSharedHotelResolver } from '../libraries/hotel/resolvers/config-shared-hotel.resolver';
import { ConfigSharedHotelModule } from "../libraries/service/resources/configuration/config-shared-hotel.module";
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';

// tslint:disable no-import-side-effect
import '../styles/angular-material/theming.scss?global';
import 'styles/angular-material/dialog.scss?global';

// Ours modules
import '../styles/angular-material/form-field.scss?global';
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { AfiMatDialogDefaultOptions } from "libraries/component/dialogs/afi-mat-dialog-default-options";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IaqobohotelRoutingModule,
        UIModule,
        CardModule,
        GenericModule,
        ApiModule,
        TravellerCardModule,
        DatePipeModule,
        PricePipesModule,
        PricePipeModule,
        ConfigSharedHotelModule,
        FontAwesomeModule,
    ],
    declarations: [
        IaqobohotelComponent,
        BreadcrumbComponent
    ],
    bootstrap: [
        IaqobohotelComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    providers: [
        ConfigSharedHotelResolver,
        LanguageService,
        HotelService,
        FormService,
        HelperService,
        QuotationService,
        BreadcrumbService,
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: new AfiMatDialogDefaultOptions()},
    ]
})
export class IaqobohotelModule { }
